// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2jRSZ","inner":"styles_inner__2Jdw7"};